
import Vue from "vue";
import Component from "vue-class-component";

const PostInscriptionProps = Vue.extend({
  props: {
    checkMail: Boolean,
    urlEspacePerso: String
  }
});

@Component({})
export default class PostInscription extends PostInscriptionProps {}
